import React, { FunctionComponent, useEffect } from 'react';
import { Switch } from 'react-router-dom';
import MakeSubRoutes from './makeSubRoutes';
import { portalRoutes } from './routes';
import Menu from '../components/Menu';
import Toaster from '../components/Toaster';
import Loader from '../components/Loader';
import { buildDate } from '../utils/buildInfo';

const Portal: FunctionComponent<any> = (props) => {
  useEffect(() => {
    console.log('Build Code: ' + buildDate);
  }, []);

  return (
    <div>
      <Menu type="OPERATOR" />
      <Switch>
        {portalRoutes.map((route: object, index: number) => (
          <MakeSubRoutes key={index} {...route} />
        ))}
      </Switch>
      <Toaster />
      <Loader />
    </div>
  );
};

export default Portal;
